import encartTranslator from '@/services/catalogue/validation/champsEncartTranslator';
import prestationTranslator from '@/services/catalogue/validation/champsPrestationTranslator';
import reglesAchatTranslator from '@/services/catalogue/validation/champsReglesAchatTranslator';
import objectifsVenteTranslator from '@/services/catalogue/validation/champsObjectifVenteTranslator';
import commissionsVendeurTranslator from '@/services/catalogue/validation/champsCommissionsVendeurTranslator';
import cgvsTranslator from '@/services/catalogue/validation/champsCgvsTranslator';
import demandeTechniqueTranslator from '@/services/catalogue/validation/champsDemandeTechniqueTranslator';

export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete.indexOf('produitReseau') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Categorie') {
      return i18n.t('catalogue.newProduct.reseauCategorie');
    }
    if (libellePropriete.indexOf('DateDebut') !== -1) {
      return i18n.t('catalogue.newProduct.startDate');
    }
    if (libellePropriete.indexOf('quantiteFaces') !== -1) {
      return i18n.t('catalogue.newProduct.quantiteFacePrevu');
    }
    if (libellePropriete.indexOf('affimetrie') === 0) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'grp') {
        return 'centreCommercialEmplacement.grp';
      }
    }
  }
  if (propriete.indexOf('produitReseauNumerique') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete.indexOf('dateDebut') !== -1) {
      return i18n.t('catalogue.newProduct.startDate');
    }
    if (libellePropriete === 'FormatId') {
      return i18n.t('catalogue.newProduct.format');
    }
  }
  if (propriete.indexOf('produitEcranNumerique') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Latitude') {
      return i18n.t('catalogue.newProduct.latitude');
    }
    if (libellePropriete === 'Longitude') {
      return i18n.t('catalogue.newProduct.longitude');
    }
  }
  if (propriete.indexOf('Affimetrie') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete.indexOf('Repetition') !== -1) {
      return i18n.t('catalogue.validation.repetition');
    }
    if (libellePropriete.indexOf('PourcentCouverture') !== -1) {
      return i18n.t('catalogue.validation.pourcentCouverture');
    }
  }

  if (propriete.indexOf('liaisonsTarif') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete.indexOf('DateDebut') !== -1) {
      return i18n.t('catalogue.newProduct.startDate');
    }
  }
  if (propriete.indexOf('Adresse') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Ville') {
      return i18n.t('catalogue.newProduct.city');
    }
    if (libellePropriete === 'Latitude') {
      return i18n.t('catalogue.newProduct.latitude');
    }
    if (libellePropriete === 'Longitude') {
      return i18n.t('catalogue.newProduct.longitude');
    }
  }
  if (propriete.indexOf('produitFace') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Ville') {
      return i18n.t('catalogue.newProduct.city');
    }
    if (libellePropriete === 'Format') {
      return i18n.t('catalogue.newProduct.format');
    }
    if (libellePropriete === 'CodePanneau') {
      return i18n.t('catalogue.newProduct.codePanneau');
    }
    if (libellePropriete === 'Latitude') {
      return i18n.t('catalogue.newProduct.latitude');
    }
    if (libellePropriete === 'Longitude') {
      return i18n.t('catalogue.newProduct.longitude');
    }
  }
  if (propriete.indexOf('produitSalon') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'DateDebut') {
      return i18n.t('produitSalon.dates.dateDebut');
    }
  }
  if (propriete.indexOf('produitSponsoring') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'DateDebut') {
      return i18n.t('produitSalon.dates.dateDebut');
    }
  }
  if (propriete.indexOf('produitAutre') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'DateDebut') {
      return i18n.t('produitSalon.dates.dateDebut');
    }
  }
  if (propriete.indexOf('produitPresse') !== -1) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'DateDebut') {
      return i18n.t('produitSalon.dates.dateDebut');
    }
    if (propriete.indexOf('Encarts') !== -1) {
      libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
      if (libellePropriete === 'Libelle') {
        return i18n.t('produitPresse.errors.libelle');
      }
      if (libellePropriete === 'DateDebut') {
        return i18n.t('produitPresse.errors.dateDebut');
      }
      if (libellePropriete === 'SurfaceId') {
        return i18n.t('produitPresse.errors.surface');
      }
      if (libellePropriete === 'EmplacementId') {
        return i18n.t('produitPresse.errors.emplacement');
      }
      if (libellePropriete === 'CouleurEncartId') {
        return i18n.t('produitPresse.errors.couleur');
      }
    }
  }
  if (propriete === 'reference') {
    return i18n.t('catalogue.newProduct.productReference');
  }
  if (propriete === 'libelle') {
    return i18n.t('catalogue.newProduct.productLabel');
  }
  if (propriete === 'stockable') {
    return i18n.t('catalogue.newProduct.stockable');
  }
  if (propriete === 'produitOpposeLieId') {
    return i18n.t('catalogue.newProduct.produitAchatLie.title');
  }
  if (propriete === 'commentaireVente') {
    return i18n.t('catalogue.newProduct.commentaireVente');
  }
  if (propriete.indexOf('liaisonsTarif') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'dateDebut') {
      return i18n.t('catalogue.newProduct.startDate');
    }
    if (libellePropriete === 'DateFin') {
      return i18n.t('catalogue.newProduct.endDate');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('catalogue.newProduct.prixUnitaire');
    }
    if (libellePropriete === 'Libelle') {
      return i18n.t('catalogue.newProduct.produit');
    }
  }

  if (propriete.indexOf('entiteCommerciale') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'indiceCsp') {
      return 'centreCommercialEmplacement.indiceCsp';
    }
    if (libellePropriete === 'nbHabitantsAireUrbaine') {
      return 'centreCommercialEmplacement.habitantAirUrbaine';
    }
    if (libellePropriete === 'audienceAn') {
      return 'centreCommercialEmplacement.audianceAn';
    }
    if (libellePropriete === 'nbContactsAn') {
      return 'centreCommercialEmplacement.nbContactAn';
    }
    if (libellePropriete === 'audienceHebdo') {
      return 'centreCommercialEmplacement.audianceHebdo';
    }
    if (libellePropriete === 'nbContactsHebdo') {
      return 'centreCommercialEmplacement.nbContactHebdo';
    }
  }

  if (propriete.indexOf('produitDivers') === 0 || propriete.indexOf('produitLocation') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Quantite') {
      return i18n.t('catalogue.newProduct.quantite');
    }
    if (libellePropriete === 'PrixUnitaire') {
      return i18n.t('catalogue.newProduct.prixUnitaire');
    }
  }

  if (libellePropriete === 'sujet') {
    return i18n.t('catalogue.validation.demandeTechnique.sujet');
  }
  if (libellePropriete === 'ordreRealisation') {
    return i18n.t('catalogue.validation.demandeTechnique.ordreRealisation');
  }
  if (libellePropriete === 'typeOtId') {
    return i18n.t('catalogue.validation.demandeTechnique.typeOt');
  }

  if (propriete.indexOf('prestation') !== -1) return prestationTranslator(i18n, propriete);
  if (propriete.indexOf('encart') !== -1) return encartTranslator(i18n, propriete);
  if (propriete.indexOf('reglesAchat') !== -1) return reglesAchatTranslator(i18n, propriete);
  if (propriete.indexOf('objectifsVente') !== -1) return objectifsVenteTranslator(i18n, propriete);
  if (propriete.startsWith('commissionsVendeur')) return commissionsVendeurTranslator(i18n, propriete);
  if (propriete.startsWith('cgvs')) return cgvsTranslator(i18n, propriete);
  if (propriete.startsWith('demandeInterventionTypes')) return demandeTechniqueTranslator(i18n, propriete);
  if (propriete.indexOf('produitDispositif') === 0) {
    if (propriete === 'produitDispositif.MaterielTypeId') {
      return i18n.t('catalogue.validation.materielType');
    }
    if (propriete === 'produitDispositif.DispositifTypeId') {
      return i18n.t('catalogue.validation.dispositifType');
    }
    if (propriete === 'produitDispositif.MaterielFormatId') {
      return i18n.t('catalogue.validation.materielFormat');
    }
    if (propriete === 'produitDispositif.DispositifSupportId') {
      return i18n.t('catalogue.validation.dispositifSupport');
    }
  }
  return propriete;
}
